module.exports = __webpack_public_path__ + "img/box-skins-blue11.d3a02f0f.jpg";